import { useEffect } from "react";

export const useTitle = (title) => {

    useEffect(() => {
        document.title = `${title} - ASF Terrassement Pont-de-Roide (25)`;
    }, [title]);

    return null;
}